import { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import { Button, Dropdown } from "react-bootstrap";
import { Download, ChevronRight, FileText, Trophy, XCircle } from "lucide-react";
import { Link } from "react-router-dom";
import "../styles/OperationReport.css";
import { PieChart, Pie, Cell,  } from "recharts";
import { useAuth } from "../context/AuthContext";
import { InputGroup, Form } from "react-bootstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";

function OperationsReport() {

  const [activeTimeRange, setActiveTimeRange] = useState("1 wk");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [customer, setCustomer] = useState("All");
  const [status, setStatus] = useState("All");
  const { role } = useAuth();

  const isAdmin = role === "admin";
  const customers = ["All", "Customer A", "Customer B"];
  const isOperations = role === "operations"; 
  const [stats, setStats] = useState([
    {
      icon: <FileText size={20} />,
      value: "0",
      label: "Total customers handled",
      bg: "#e7f0ff",
      color: "#3b82f6"
    },
    {
      icon: <Trophy size={20} />,
      value: "0",
      label: "Tenders assigned",
      bg: "#e6f6ec",
      color: "#16a34a"
    },
    {
      icon: <XCircle size={20} />,
      value: "0",
      label: "Tenders submitted",
      bg: "#fdeaea",
      color: "#dc2626"
    }
  ]);

  const [data, setData] = useState([
    { name: "Total Tenders Submitted", value: 0, color: "#ef4444" },
    { name: "Awaiting customer approval", value: 0, color: "#eab308" },
    { name: "Ready for submission", value: 0, color: "#10b981" },
    { name: "Clarification Pending", value: 0, color: "#6b7280" }
  ]);

  const reportRef = useRef(null);

  const handleDownloadPDF = async () => {
    const element = reportRef.current;
    if (!element) return;
    try {
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Operations_Report.pdf");
    } catch (error) {
      console.error("Failed to generate PDF", error);
    }
  };

  const getPastDate = (days) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return d.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (activeTimeRange === "1 wk") {
      setStartDate(getPastDate(7));
      setEndDate(getPastDate(0));
    } else if (activeTimeRange === "1 mo") {
      setStartDate(getPastDate(30));
      setEndDate(getPastDate(0));
    } else if (activeTimeRange === "3 mo") {
      setStartDate(getPastDate(90));
      setEndDate(getPastDate(0));
    }
  }, [activeTimeRange]);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        let url = `${process.env.REACT_APP_BASE_API_URL || "http://localhost:5000"}/api/operations-report?`;
        if (startDate && endDate) {
          url += `startDate=${startDate}&endDate=${endDate}`;
        }
        
        const res = await axios.get(url, { 
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          withCredentials: true 
        });
        const resData = res.data.data;
        
        setStats([
          {
            icon: <FileText size={20} />,
            value: resData?.totalCustomers?.toString() || "0",
            label: "Total customers handled",
            bg: "#e7f0ff",
            color: "#3b82f6"
          },
          {
            icon: <Trophy size={20} />,
            value: resData?.tendersAssigned?.toString() || "0",
            label: "Tenders assigned",
            bg: "#e6f6ec",
            color: "#16a34a"
          },
          {
            icon: <XCircle size={20} />,
            value: resData?.tendersSubmitted?.toString() || "0",
            label: "Tenders submitted",
            bg: "#fdeaea",
            color: "#dc2626"
          }
        ]);

        if (resData?.pieData) {
          setData(resData.pieData);
        }

      } catch (err) {
        console.error("Failed to fetch operations report data:", err);
      }
    };
    if(startDate && endDate) {
      fetchReportData();
    }
  }, [startDate, endDate]);



  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    index
  }) => {
    const radius = outerRadius + 25;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    const lineX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const lineY = cy + outerRadius * Math.sin(-midAngle * RADIAN);

    const item = data[index];

    return (
      <>
        <line
          x1={lineX}
          y1={lineY}
          x2={x}
          y2={y}
          stroke={item.color}
          strokeWidth={1.5}
        />
        <text
          x={x}
          y={y}
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
          style={{ fontSize: "13px", fill: "#333" }}
        >
          {item.name}: {item.value}%
        </text>
      </>
    );
  };

 const datas = [
    { week: "Week 1", value: 25 },
    { week: "Week 2", value: 45 },
    { week: "Week 3", value: 45 },
    { week: "Week 4", value: 75 }
  ];
  return (
    <>
       <nav
      aria-label="breadcrumb"
      style={{
        "--bs-breadcrumb-divider": "''",
      }}
    >
      <ol
        className="breadcrumb d-flex align-items-center py-2 mb-0"
        style={{ fontSize: "14px" }}
      >
        <li className="breadcrumb-item d-flex align-items-center">
          <Link to="/" className="text-decoration-none text-secondary">
            Home
          </Link>
          <ChevronRight size={16} className="mx-1 text-secondary" />
        </li>
    
        <li
          className="breadcrumb-item fw-semibold"
          style={{ color: "#2F7A87" }}
        >
Report         </li>
      </ol>
    </nav>

      <div className="task-container container-fluid">

        {/* Header */}
        <div className="task-header mb-4 d-flex justify-content-between align-items-center">
          <div>
            <div className="d-flex align-items-center">
              <h4 className="task-title mb-0">Report</h4>
            </div>

            <span className="task-subtitle">
              Monitor tender processing activity across employees and customers.
            </span>
          </div>

          <button className="operation-button" onClick={handleDownloadPDF}>
                            <i className="bi bi-download me-2 down-image"></i>
                            Download
                        </button>
        </div>
        
        {/* Wrap content for PDF download */}
        <div ref={reportRef} style={{ background: "#fff", padding: "15px", borderRadius: "8px" }}>
        {isAdmin && (
          <div className="view-by-content row align-items-center mb-3">
        
            <div className="col-auto">
              <label className="mb-0 fw-semibold">View By :</label>
            </div>
        
            <div className="col-2">
              <InputGroup>
                <Form.Select>
                  <option value="all">All</option>
                  <option value="employee">Employee</option>
                  <option value="operations">Operations</option>
                </Form.Select>
              </InputGroup>
            </div>
        
          </div>
        )}
<div className="filters-container operations-filters d-flex flex-wrap align-items-end bg-white p-3 rounded">

<div className="time-range-group">
  <span className="time-range-label">Time Range:</span>

  <div className="time-range-buttons">
    {["1 wk", "1 mo", "3 mo"].map((range) => (
      <button
        key={range}
        className={`time-pill ${activeTimeRange === range ? "active" : ""}`}
        onClick={() => setActiveTimeRange(range)}
      >
        {range}
      </button>
    ))}
  </div>
</div>

  {/* Start Date */}
  <div className="filter-group ms-lg-5">
    <label className="filter-label">Start</label>
    <input
      type="date"
      className="form-control custom-input"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
  </div>

  {/* End Date */}
  <div className="filter-group">
    <label className="filter-label">End</label>
    <input
      type="date"
      className="form-control custom-input"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>

{isOperations && (
  <div className="filter-group">
    <label className="filter-label">Customer</label>

    <Dropdown className="operations-dropdown">
      <Dropdown.Toggle className="filter-pill operations-filter-pill d-flex justify-content-between align-items-center">
        <span>{customer}</span>
        <i className="bi bi-chevron-down ms-2"></i>
      </Dropdown.Toggle>

      <Dropdown.Menu className="operations-dropdown-menu" renderOnMount>
        {customers.map((c) => (
          <Dropdown.Item key={c} onClick={() => setCustomer(c)}>
            {c}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </div>
)}

{/* Status */}
<div className="filter-group">
  <label className="filter-label">Customer Status</label>

<Dropdown className="operations-dropdown">
<Dropdown.Toggle className="filter-pill operations-filter-pill d-flex justify-content-between align-items-center">
  <span>{status}</span>
  <i className="bi bi-chevron-down ms-2"></i>
</Dropdown.Toggle>

   <Dropdown.Menu className="operations-dropdown-menu" renderOnMount>
      <Dropdown.Item onClick={() => setStatus("All")}>All</Dropdown.Item>
      <Dropdown.Item onClick={() => setStatus("Approved")}>Approved</Dropdown.Item>
      <Dropdown.Item onClick={() => setStatus("Rejected")}>Rejected</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
</div>

</div>
        <div className="stats-container mt-3 ">
          {stats.map((item, index) => (
            <div key={index} className="stats-card d-flex align-items-center">
              <div className="stats-icon" style={{ background: item.bg, color: item.color }}>
                {item.icon}
              </div>
              <div>
                <h5 className="mb-0 fw-bold">{item.value}</h5>
                <span className="text-muted small">{item.label}</span>
              </div>
            </div>
          ))}
        </div>

      <div className="chart-row">     
           <div className="chart-card">
          <h5 className="chart-title">Status across selected customers</h5>

          <div className="chart-content d-flex justify-content-center align-items-center" style={{ minHeight: "320px" }}>
            {data.reduce((acc, curr) => acc + curr.value, 0) === 0 ? (
              <span className="text-muted">No data available for this time range.</span>
            ) : (
              <PieChart width={500} height={320}>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={90}
                  outerRadius={120}
                  dataKey="value"
                  labelLine={false}
                  label={renderCustomizedLabel}
                >
                  {data.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            )}
          </div>

          <div className="chart-total">
            Total: <strong>{data.reduce((acc, curr) => acc + curr.value, 0)}</strong>
          </div>
        </div>
<div className="trend-card">
  <h5 className="trend-title">Tender Submission Trend</h5>

<LineChart width={500} height={365}
    data={datas}   // ✅ FIXED
    margin={{ top: 10, right: 30, left: 10, bottom: 0 }}
  >
    <CartesianGrid stroke="#e5e7eb" vertical={false} />

    <XAxis
      dataKey="week"   // ✅ FIXED
      tick={{ fontSize: 13, fill: "#6b7280" }}
      axisLine={{ stroke: "#9ca3af" }}
      tickLine={false}
    />

    <YAxis
      tick={{ fontSize: 13, fill: "#6b7280" }}
      axisLine={false}
      tickLine={false}
    />

    <Line
      type="monotone"
      dataKey="value"   // ✅ FIXED
      stroke="#ef4444"
      strokeWidth={2}
      dot={false}
      activeDot={false}
    />
  </LineChart>
</div>
    </div>
        </div> {/* End of reportRef */}
      </div>
    </>
  );
}

export default OperationsReport;